import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { Route } from 'react-router';
import { DocumentContent } from './DocumentContent';
import { OrderContent } from './OrderContent';
import { CreditContent } from './CreditContent';
import { ChangePassword } from './ChangePassword';

import { SessionTimedOut } from './SessionTimedOut';
import { Product } from './Products';
import { Login } from './Login';
import { CheckOut } from './CheckOut';
import { SavedCarts } from './SavedCarts';
import { OrderSearch } from './OrderSearch'
import { Budget } from './Budget'
import { AdminUser } from './AdminUser'
import { Users } from './Users';
import { ClearCartPrompt } from './ClearCartPrompt';
import { OrderApproval } from './OrderApproval';
import { DocumentsManage } from './DocumentsManage';
import { AdminManage } from './AdminManage';

export class InvoiceOrderSearch extends Component {
    displayName = InvoiceOrderSearch.name

    constructor(props) {
        super(props);

        this.state = {
            valid: false,
            userDetails: {},
            referenceNumber: '',
            startDate: '',
            startDateBorderColor: '',
            endDate: '',
            endDateBorderColor: '',
            documentType: 'All',
            toClearCartPrompt: false,
            toChangePassword: false,
            menuVisibility: 'hidden',

            invoices: [],
            loadingInvoices: false,
            invoicesVisibility: 'hidden',
            invoicesHeight: '0',

            credits: [],
            loadingCredits: false,
            creditsVisibility: 'hidden',
            creditsHeight: '0',

            orders: [],
            loadingOrders: false,
            ordersVisibility: 'hidden',
            ordersHeight: '0',

            ToDocument: false,
            ToOrderDocument: false,
            ToCreditDocument: false,
            toProductsPage: false,

            toProducts: false,
            toCheckOut: false,
            toSaveCart: false,
            toManage: false,
            toOrderForm: false,
            toAdmin: false,
            toLogIn: false,
            toBudgets: false,
            toOrderSearch: false,
            toOrderApproval: false,
            toSavedCarts: false,
            canTrack: 'hidden',
            isAdminVisibile: 'hidden',
            stylesheet: '',
            toSessionTimedOut: false,
            isValidDate: false,
            invalidDateMessage: '',
            invalidDateModalVisibility: 'hidden',
            toDocumentsManage: false,
        };
        this.CheckSessionInitialize();
    }


    CheckSessionInitialize() {
        this.setState({ complete_update: false });
        console.log('get CheckSession called');

        fetch('api/Login/CheckSession?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == 'running') {
                    this.setState({ toSessionTimedOut: false });

                    this.GetUserDetails();
                    this.CheckIfAdmin();
                    this.CheckIfCanTrack();
                }
                else if (data == 'timedout') {
                    this.setState({ toSessionTimedOut: true });
                }
            });
    }

    CheckSession() {
        this.setState({ complete_update: false });
        console.log('get CheckSession called');

        fetch('api/Login/CheckSession?buster=' + + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == 'running') {
                    this.setState({ toSessionTimedOut: false });
                }
                else if (data == 'timedout') {
                    this.setState({ toSessionTimedOut: true });
                }
            });
    }

    ProductLink() {
        this.setState({ toProductsPage: true });
    }

    handleReferenceNumberChange(e) {
        this.setState({ referenceNumber: e.target.value },
            () => {
                console.log('reference : ' + this.state.referenceNumber);
            }
        );
    }

    handleStartDateChange(e) {

        this.setState({ startDate: e.target.value },
            () => {
                console.log('Start Date : ' + this.state.startDate);
            }
        );
    }

    handleEndDateChange(e) {
        this.setState({ endDate: e.target.value },
            () => {
                console.log('End Date : ' + this.state.endDate);
            }
        );
    }



    handleDocumentTypeChange(e) {
        this.setState({ documentType: e.target.value },
            () => {
                console.log('Document Type : ' + this.state.documentType);

                if (this.state.documentType == 'All') {
                    this.setState({
                        invoicesHeight: '500px',
                        invoicesVisibility: 'Visible',
                        creditsHeight: '500px',
                        creditsVisibility: 'Visible'
                    });
                }
                else if (this.state.documentType == 'Credits') {
                    this.setState({
                        creditsHeight: '500px',
                        creditsVisibility: 'Visible',
                        invoicesHeight: '0',
                        invoicesVisibility: 'hidden',
                        ordersHeight: '0',
                        ordersVisibility: 'hidden'
                    });
                }
                else if (this.state.documentType == 'Invoices') {
                    this.setState({
                        invoicesHeight: '500px',
                        invoicesVisibility: 'Visible',
                        creditsHeight: '0',
                        creditsVisibility: 'hidden',
                        ordersHeight: '0',
                        ordersVisibility: 'hidden'
                    });
                }
                else if (this.state.documentType == 'Orders') {
                    this.setState({
                        ordersHeight: '500px',
                        ordersVisibility: 'visible',
                        invoicesHeight: '0',
                        invoicesVisibility: 'Hidden',
                        creditsHeight: '0',
                        creditsVisibility: 'hidden'
                    });
                }
            }
        );
    }

    GetDocumentsByReference() {

        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            console.log('Getting Documents By Reference');
            if (this.state.documentType == 'All') {
                this.GetInvoicesByRef();
                this.GetCreditsByRef();
            }
            else if (this.state.documentType == 'Credits') {
                this.GetCreditsByRef();
            }
            else if (this.state.documentType == 'Invoices') {
                this.GetInvoicesByRef();
            }
        }
    }

    GetDocuments() {

        this.CheckSession();

        fetch('api/InvoiceOrder/ValidateDates?startDate=' + this.state.startDate + '&endDate=' + this.state.endDate + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == 'Available') {
                    this.setState({ isValidDate: true });

                    if (this.state.toSessionTimedOut == false) {
                        console.log('Getting Documents By Reference');
                        if (this.state.documentType == 'All') {
                            this.GetInvoicesByDate();
                            this.GetCreditsByDate();
                            this.GetOrdersByDate();
                        }
                        else if (this.state.documentType == 'Credits') {
                            this.GetCreditsByDate();
                        }
                        else if (this.state.documentType == 'Invoices') {
                            this.GetInvoicesByDate();
                        }

                    }
                }
                else {
                    this.setState({ invalidDateMessage: data, invalidDateModalVisibility: 'visible' });
                }
            });


    }


    GetInvoicesByRef() {

        this.setState({ loadingInvoices: true });

        fetch('api/InvoiceOrder/GetInvoicesByReference?referenceNo=' + this.state.referenceNumber + '&startDate = ' + this.state.startDate + '&endDate=' + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => {
                this.setState({ invoices: data, loadingInvoices: false },
                    () => { console.log('invoices by reference'); console.log(this.state.invoices) });
            })
            .then(() => {

            });
    }

    GetInvoicesByDate() {

        this.setState({ loadingInvoices: true });

        fetch('api/InvoiceOrder/GetInvoicesByDate?startDate=' + this.state.startDate + '&endDate=' + this.state.endDate + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => {
                this.setState({ invoices: data, loadingInvoices: false },
                    () => { console.log('invoices'); console.log(this.state.invoices) });
            })
            .then(() => {

            });
    }


    GetCreditsByRef() {

        this.setState({ loadingCredits: true });

        fetch('api/InvoiceOrder/GetCreditsByReference?referenceNo=' + this.state.referenceNumber + '&startDate = ' + this.state.startDate + '&endDate=' + this.state.endDate  + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => {
                this.setState({ credits: data, loadingCredits: false });
            })
            .then(() => { });
    }

    SetInvoiceIdentifier(invoiceId) {

        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('api/InvoiceOrder/SetInvoiceIdentifier?invoiceId=' + invoiceId + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(() => { this.setState({ ToDocument: true }) });
        }
    }

    GetCreditsByDate() {

        this.setState({ loadingCredits: true });

        fetch('api/InvoiceOrder/GetCreditsByDate?startDate=' + this.state.startDate + '&endDate=' + this.state.endDate + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => {
                this.setState({ credits: data, loadingCredits: false });
            })
            .then(() => { });
    }

    GetOrdersByDate() {

        this.setState({ loadingOrders: true });

        fetch('api/InvoiceOrder/GetOrdersByDate?startDate=' + this.state.startDate + '&endDate=' + this.state.endDate + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => {
                this.setState({ orders: data, loadingOrders: false },
                    () => { console.log('orders'); console.log(this.state.orders) });
            })
            .then(() => {

            });
    }

    GetOrdersByRef() {

        this.setState({ loadingOrders: true });

        fetch('api/InvoiceOrder/GetOrdersByReference?referenceNo=' + this.state.referenceNumber + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => {
                this.setState({ orders: data, loadingOrders: false });
            })
            .then(() => { console.log('orders'); console.log(this.state.orders); });
    }

    SetOrderIdentifier(orderId) {

        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('api/InvoiceOrder/SetOrderIdentifier?orderId=' + orderId + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(() => { this.setState({ ToOrderDocument: true }) });
        }
    }

    SetCreditIdentifier(creditId) {

        this.CheckSession();

        if (this.state.toSessionTimedOut == false) {
            fetch('api/InvoiceOrder/SetCreditIdentifier?creditId=' + creditId + '&buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
                .then(() => { this.setState({ ToCreditDocument: true }) });
        }
    }

    renderOrders() {
        console.log('loading orders');
        if (this.state.loadingOrders) {
            return (<tr><td>Loading</td></tr>);
        }
        else {
            return (this.state.orders.map(order =>
                <tr style={{ backgroundColor: 'white' }}>
                    <td className="sideBorder" style={{ padding: '0 20px', color: 'blue', border: 'black' }} onClick={() => this.SetOrderIdentifier(order.orderID)}>{order.orderID}</td>
                    <td className="sideBorder" style={{ padding: '0 20px' }}> {order.customerID} </td>
                    <td className="sideBorder" style={{ padding: '0 20px' }}> {order.orderDate} </td>
                    <td className="sideBorder" style={{ padding: '0 20px' }}> {order.deliveryDate} </td>
                    <td className="sideBorder" style={{ padding: '0 20px' }}> {order.deliveryAddressID}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {order.ordernotes}  </td>
                    <td className="sideBorder" style={{ padding: '0 20px' }}> {order.orderStatusCode}  </td>
                </tr>
            )
            );
        }

    }

    renderInvoices() {
        console.log('loading invoices');
        if (this.state.loadingInvoices) {
            return (<tr>
                <td colspan="11">
                    <div style={{ textAlign: 'center' }}>
                        <div>
                            <div className="spinner-border" style={{ color: 'black' }} role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>);
        }
        else {
            return (this.state.invoices.map(invoice =>
                <tr style={{ backgroundColor: 'white' }} >
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}>{invoice.warehouseCode}</td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px', color: 'blue', border: 'black', cursor: 'pointer' }} onClick={() => this.SetInvoiceIdentifier(invoice.invoiceNo)}>{invoice.invoiceNo}</td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.invoiceDate} </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.accountCode} </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.invoiceTo1}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.invoiceTo2}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.invoiceTo3}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.invoiceTo4}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.deliverTo1}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.deliverTo2}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.deliverTo3}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.deliverTo4}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.terms}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.custRef}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.ourRef}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.noOfItems}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.freight}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> R {invoice.otherCharges}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> R {Number(invoice.invoiceTotal).toFixed(2)}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {Number(invoice.discount).toFixed(2)}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.ediRef}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.deliveryInstructions}  </td>
                    <td className="sideBorder overflow_table" style={{ padding: '0 20px' }}> {invoice.dateDelivered}  </td>
                </tr>
            )
            );
        }

    }

    renderCredits() {
        if (this.state.documentType != 'Invoices') {
            console.log('loading Credits');
            if (this.state.loadingCredits) {
                return (<tr>
                    <td colspan="11">
                        <div style={{ textAlign: 'center' }}>
                            <div>
                                <div className="spinner-border" style={{ color: 'black' }} role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>);
            }
            else {
                return (this.state.credits.map(credit =>
                    <tr style={{ backgroundColor: 'white' }}>
                        <td style={{ padding: '0 20px' }} className="sideBorder"> {credit.warehouseId}    </td>
                        <td className="sideBorder" style={{ padding: '0 20px', color: 'blue', border: 'black', cursor: 'pointer' }} onClick={() => this.SetCreditIdentifier(credit.creditNo)}>{credit.creditNo}</td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.creditDate}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.accountCode}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.accountName}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.creditToL1}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.creditToL2}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.creditToL3}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.creditToL4}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.deliverToL1}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.deliverToL2}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.deliverToL3}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.deliverToL4}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.comments}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.custRef}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.ourRef}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.invoiceNo}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.noOfItems}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> {credit.freight}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> R {credit.otherCharges}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> R {Number(credit.tax).toFixed(2)}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> R {Number(credit.creditTotal).toFixed(2)}  </td>
                        <td style={{ padding: '0 20px' }} className="sideBorder overflow_table"> R {credit.discount}  </td>
                    </tr>
                )
                );
            }
        }
    }

    ExitModal() {
        this.setState({ invalidDateModalVisibility: 'hidden' });

    }

    ToChangePassword() {
        fetch('/api/Login/CanUpdatePassword' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(response => {

                if (response == 'true')
                    this.setState({ toChangePassword: true });
                else
                    alert('You currently do not have the required permissions to change your password.');

            });
    }

    MenuClick() {

        if (this.state.menuVisibility == 'hidden') {
            this.setState({ menuVisibility: 'visible' });
        }
        else if (this.state.menuVisibility == 'visible') {
            this.setState({ menuVisibility: 'hidden' });
        }
    }


    render() {

        //Route Change
        if (this.state.toSessionTimedOut) {
            return <Route path='/' component={SessionTimedOut} />
        }

        if (this.state.toClearCartPrompt) {
            return <Route path='/' component={ClearCartPrompt} />
        }


        if (this.state.GoToOrderSearch) {
            return <Route path='/' component={OrderSearch} />
        }

        if (this.state.toBudgets) {
            return <Route path='/' component={Budget} />
        }

        if (this.state.toSavedCarts) {
            return <Route path='/' component={SavedCarts} />
        }

        if (this.state.toCheckOut) {
            return <Route path='/' component={CheckOut} />
        }


        if (this.state.toOrderApproval) {
            return <Route path='/' component={OrderApproval} />
        }

        if (this.state.toLogIn) {
            return <Route path='/' component={Login} />
        }

        if (this.state.toProducts) {
            return <Route path='/' component={Product} />
        }

        if (this.state.toAdmin) {
            return <Route path='/' component={AdminManage} />
        }

        if (this.state.toClearCartPrompt) {
            return <Route path='/' component={ClearCartPrompt} />
        }

        if (this.state.toDocumentsManage) {
            return <Route path='/' component={DocumentsManage} />
        }

        ///end

        if (this.state.ToCreditDocument) {
            return <Route path='/' component={CreditContent} />
        }

        if (this.state.ToDocument) {
            return <Route path='/' component={DocumentContent} />
        }


        if (this.state.toChangePassword) {
            return <Route path='/' component={ChangePassword} />

        }

        if (this.state.ToOrderDocument) {
            return <Route path='/' component={OrderContent} />
        }

        let invoiceRows = this.renderInvoices();
        let orderRows = this.renderOrders();
        let creditRows = this.renderCredits();

        return (
            <div>
                <link href={this.state.stylesheet} rel="stylesheet" />
                <div style={{ top: '0', left: '0', height: '100%' }}>
                    <div className="header" style={{ position: 'fixed', zIndex : '500'}}>
                        <div className="grid_container_header" style={{ msHyphens: 'auto', display: 'inline-grid', gridTemplateColumns: '30% 40% 30%', display: 'grid -ms-grid', msGridColumns: '30% 40% 30%', columnCount: '3' }}>
                            <div className="grid_header">
                                <div className="icon_home" style={{ width: '100%', height: '50%', 'margin-top': '30px', 'margin-left': '10%', float: 'left', 'background-repeat': 'no-repeat' }}></div>
                            </div>
                            <div className="grid_header" style={{ 'text-align': 'left', overflow: 'hidden' }}>
                                <div className="header_container" style={{ width: '100%' }}>
                                    <div>
                                        <div style={{ display: 'inline' }}>
                                            <a className="header_text" onClick={() => this.GoBackToProducts()}  >Place Order</a>|
                                                <a className="header_text" onClick={() => this.GoToDocumentsManage()} >Documents</a><span style={{ visibility: this.state.canTrack }}>|</span>
                                            <a className="header_text" onClick={() => this.GoToOrderApproval()} style={{ visibility: this.state.canTrack }} >Order Approval</a>
                                            <span style={{ visibility: 'visible' }}>|</span>
                                            <a className="header_text" onClick={() => this.GoToBudget()} style={{ visibility: 'visible' }}>Budgets</a>
                                            <span style={{ visibility: this.state.isAdminVisibile }}>|</span>
                                            <a className="header_text" onClick={() => this.GoToAdmin()} style={{ visibility: this.state.isAdminVisibile }} >Admin</a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="grid_header">
                                <div className="header_container greeting" style={{ width: '100%' }}>
                                    <div className="header_text grid_item_1" style={{ lineHeight: '40px', textAlign: 'right' }}>
                                        <div style={{ height: '28px' }} className="overflow_header"> {this.state.userDetails.greeting + ', ' + this.state.userDetails.fullname}</div>
                                        <div style={{ height: '25px' }} className="overflow_header">{this.state.userDetails.accountName}</div>
                                        <div style={{ height: '28px' }} className="overflow_header">Group : {this.state.userDetails.accountCode}</div>
                                    </div>
                                    <div className="grid_item_2_reverse  h100">
                                        <div style={{ width: '100%', 'height': '100%' }}>
                                            <button id="btnMenu" onClick={() => this.MenuClick()} className="btn primary_btn header_btn twfont" style={{ lineHeight: '0.8', marginTop: '10px'  }}  ><i className="material-icons" style={{ width: '100%' }} >menu</i><label>Options</label></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="header_menu_container" style={{ visibility: this.state.menuVisibility }}>
                        <div className="grid_item_1 max-height-menu">
                            <button onClick={() => { this.MenuClick() }} style={{ width: '100%', height: '100%', backgroundColor: 'transparent', backgroundColor: 'transparent', border: 'none' }}></button>
                        </div>
                        <div className="header_menu grid_item_2 max-height-menu customer_background_foreground">
                            <hr />
                            <div>
                                <button id="canUpdateBtn" name="canUpdateBtn" className="btn  header_menu_item" onClick={() => { this.ToChangePassword() }}>Reset Password <i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px' }}>vpn_key</i></button>
                            </div>
                            <hr />
                            <div>
                                <button className="btn  header_menu_item" onClick={() => { this.GetCartState() }}>Logout <i className="material-icons" style={{ position: 'relative', top: '6px', paddingLeft: '10px' }}>exit_to_app</i></button>
                            </div>
                            <hr />
                        </div>
                    </div>
                    <div className=" sidenav customer_background_foreground" style={{ width: '100%', minHeight: '1000px', marginTop: '100px' }}>
                        <div style={{ width: '100%', textAlign: 'center' }}>
                            <br />
                            <div className="customer_background_foreground" style={{ width: '30%', margin: '0 35%', padding: '20px', verticalAlign: 'middle', height: '300px' }}>
                                <table style={{ width: '-webkit-fill-available' }}>
                                    <tr>
                                        <td style={{ width: '100%' }}>
                                            <button ID="butSearch" className="btn secondary_btn twfont" onClick={() => this.GoToDocumentsManage()} style={{ width: '100%' }} >Back To Select Documents</button>
                                        </td>
                                    </tr>
                                    <tr><td><hr /></td></tr>
                                    <tr>
                                        <td>
                                            <label className="customer_background_foreground" style={{ fontFamily: 'Tw Cen MT', fontSize: 'large', fontWeight: 'bold', width: '100%', textAlign: 'center' }}>Invoices and Credits Search</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: '100%', fontSize: 'large', padding: '0px 20px' }}>
                                            <div className="divGridRadio">
                                                <div className="radio row1 col1">
                                                    <label className="checkbox-inline " ><input type="radio" style={{ cursor: 'pointer' }} name="optradio" value="All" onChange={this.handleDocumentTypeChange.bind(this)} /> All</label>
                                                </div>
                                                <div className="radio row1 col2">
                                                    <label className="checkbox-inline "><input type="radio" style={{ cursor: 'pointer' }} name="optradio" value="Invoices" onChange={this.handleDocumentTypeChange.bind(this)} /> Invoice</label>
                                                </div>
                                                <div className="radio row1 col3">
                                                    <label className="checkbox-inline "><input type="radio" style={{ cursor: 'pointer' }} name="optradio" value="Credits" onChange={this.handleDocumentTypeChange.bind(this)} /> Credits</label>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="default_background">
                                        <td colspan="2" style={{ width: '400px', alignContent: 'center', textAlign: 'center' }}>
                                            <div style={{ height: '15px' }}>
                                                <div className="input-group mb-3" >
                                                    <input id="refno" name="refno"  type="text" onChange={this.handleReferenceNumberChange.bind(this)} className="form-control twfont" placeholder="Search Text" />
                                                </div>
                                            </div>
                                        </td> 
                                    </tr>
                                    <tr><td><br /></td></tr>
                                    <tr className="default_background">
                                        <td colspan="2" style={{ width: '400px', alignContent: 'center', textAlign: 'center' }}>
                                            <div>
                                                <div><input id="startDate" name="startDate" type="date" onChange={this.handleStartDateChange.bind(this)} className="form-control twfont" placeholder="day-month-year e.g. (25-10-2019)" /></div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="default_background">
                                        <td colspan="2" style={{ width: '400px', alignContent: 'center', textAlign: 'center' }}>
                                            <div>
                                                <div><input id="endDate" name="endDate" type="date" onChange={this.handleEndDateChange.bind(this)} className="form-control twfont" placeholder="day-month-year e.g. (25-10-2019)" /></div>
                                            </div>
                                        </td>
                                    </tr>
                                    <br />
                                    <tr>
                                        <td style={{ width: '100%' }}>
                                            <button ID="butSearch" className="btn primary_btn twfont" onClick={() => this.GetDocumentsByReference()} style={{ width: '100%' }} >Search</button>
                                        </td>
                                    </tr>
                                    <tr><td><hr /></td></tr>

                                </table >
                            </div>
                        </div>
                        <div style={{ padding: '20px', height: '100%', width: '100%' }}>
                            <div style={{ height: '100%', width: '100%' }}>
                                <div style={{ visibility: this.state.invoicesVisibility, height: this.state.invoicesHeight }}>
                                    <hr />
                                    <div><label className="text customer_background_foreground" data-toggle="collapse" data-target="#Invoice" style={{ fontFamily: 'TW Cen MT', fontSize: 'large', textAlign: 'center', width: '100%' }}>Invoices</label></div>
                                    <hr />
                                    <div id="Invoice">
                                        <table className="table table-bordered scrollable-element" style={{ fontFamily: 'TW Cen MT', display: 'block', overflow: 'scroll', whiteSpace: 'nowrap', height: '400px', backgroundColor: 'white' }}>
                                            <thead className="customer_base_background"  >
                                                <th style={{ padding: '0 20px' }}> Warehouse Code</th>
                                                <th style={{ padding: '0 20px' }}> Invoice No</th>
                                                <th style={{ padding: '0 20px' }}> Invoice Date</th>
                                                <th style={{ padding: '0 20px' }}> Account Code</th>
                                                <th style={{ padding: '0 20px' }}> Invoice To 1</th>
                                                <th style={{ padding: '0 20px' }}> Invoice To 2</th>
                                                <th style={{ padding: '0 20px' }}> Invoice To 3</th>
                                                <th style={{ padding: '0 20px' }}> Invoice To 4</th>
                                                <th style={{ padding: '0 20px' }}> Deliver To 1</th>
                                                <th style={{ padding: '0 20px' }}> Deliver To 2</th>
                                                <th style={{ padding: '0 20px' }}> Deliver To 3</th>
                                                <th style={{ padding: '0 20px' }}> Deliver To 4</th>
                                                <th style={{ padding: '0 20px' }}> Terms</th>
                                                <th style={{ padding: '0 20px' }}> Cust Ref</th>
                                                <th style={{ padding: '0 20px' }}> Our Ref</th>
                                                <th style={{ padding: '0 20px' }}> No Of Items</th>
                                                <th style={{ padding: '0 20px' }}> Freight</th>
                                                <th style={{ padding: '0 20px' }}> Other Charges</th>
                                                <th style={{ padding: '0 20px' }}> Invoice Total</th>
                                                <th style={{ padding: '0 20px' }}> Discount</th>
                                                <th style={{ padding: '0 20px' }}> Edi Ref</th>
                                                <th style={{ padding: '0 20px' }}> Delivery Instructions</th>
                                                <th style={{ padding: '0 20px' }}> Date Delivered</th>
                                            </thead>
                                            {invoiceRows}
                                        </table>
                                    </div>
                                </div>
                                <div style={{ visibility: this.state.creditsVisibility, height: this.state.creditsHeight }}>
                                    <hr />
                                    <label className="text customer_background_foreground" style={{ fontFamily: 'TW Cen MT', fontSize: 'large', width: '100%', textAlign: 'center' }}>Credits</label>
                                    <hr />
                                    <table className="table table-bordered" style={{ fontFamily: 'TW Cen MT', display: 'block', overflow: 'scroll', whiteSpace: 'nowrap', height: '400px' }}>
                                        <thead className="customer_base_background">
                                            <th style={{ padding: '0 20px' }}> Warehouse Code</th>
                                            <th style={{ padding: '0 20px' }}> Credit No</th>
                                            <th style={{ padding: '0 20px' }}> Account Code</th>
                                            <th style={{ padding: '0 20px' }}> Account Name</th>
                                            <th style={{ padding: '0 20px' }}> Credit To 1</th>
                                            <th style={{ padding: '0 20px' }}> Credit To 2</th>
                                            <th style={{ padding: '0 20px' }}> Credit To 3</th>
                                            <th style={{ padding: '0 20px' }}> Credit To 4</th>
                                            <th style={{ padding: '0 20px' }}> Deliver To 1</th>
                                            <th style={{ padding: '0 20px' }}> Deliver To 2</th>
                                            <th style={{ padding: '0 20px' }}> Deliver To 3</th>
                                            <th style={{ padding: '0 20px' }}> Deliver To 4</th>
                                            <th style={{ padding: '0 20px' }}> comments</th>
                                            <th style={{ padding: '0 20px' }}> Cust Ref</th>
                                            <th style={{ padding: '0 20px' }}> Our Ref</th>
                                            <th style={{ padding: '0 20px' }}> Invoice No.</th>
                                            <th style={{ padding: '0 20px' }}> No Of Items</th>
                                            <th style={{ padding: '0 20px' }}> Freight</th>
                                            <th style={{ padding: '0 20px' }}> Other Charges</th>
                                            <th style={{ padding: '0 20px' }}> Tax </th>
                                            <th style={{ padding: '0 20px' }}> Total </th>
                                            <th style={{ padding: '0 20px' }}> Discount</th>
                                        </thead>
                                        {creditRows}
                                    </table>
                                    <hr />
                                </div>
                                <div style={{ visibility: this.state.ordersVisibility, height: this.state.ordersHeight }}>
                                    <hr />
                                    <label className="text customer_background_foreground" style={{ fontFamily: 'TW Cen MT', fontSize: 'large', width: '100%', textAlign: 'center' }}>Orders</label>
                                    <hr />
                                    <table className="table table-bordered" style={{ fontFamily: 'TW Cen MT', display: 'block', overflow: 'scroll', whiteSpace: 'nowrap', height: '400px' }}>
                                        <thead className="customer_background_foreground_reverse">
                                            <th style={{ padding: '0 20px' }}> Order ID</th>
                                            <th style={{ padding: '0 20px' }}> Customer ID</th>
                                            <th style={{ padding: '0 20px' }}> Order Date</th>
                                            <th style={{ padding: '0 20px' }}> Delivery Date</th>
                                            <th style={{ padding: '0 20px' }}> Delivery Address ID</th>
                                            <th style={{ padding: '0 20px' }}> Order Notes</th>
                                            <th style={{ padding: '0 20px' }}> Order Status</th>
                                        </thead>
                                        {orderRows}
                                    </table>
                                    <hr />
                                </div>
                            </div>
                        </div>
                        <div style={{ visibility: this.state.invalidDateModalVisibility }}>
                            <div className="outer-container" style={{ top: '0', fontFamily: 'TW Cent', backgroundColor: 'rgba(10,10,10, 0.8)' }} >
                                <div className="inner-container" style={{ height: '1000px' }}>
                                    <div className="centered-content twfont  customer_background_foreground"
                                        style={{ boxShadow: '2px 2px 8px #888888', border: 'none', width: '90%', maxWidth: '450px', backgroundColor: 'rgba(255,255,255,0.3)', fontFamily: 'TW Cen MT' }}>
                                        <table className="customer_background_foreground" style={{ width: '100%', margin: '0 auto', verticalAlign: 'middle', height: '150px', backgroundColor: 'rgba(255,255,255,0.3)' }}>
                                            <tbody>
                                                <tr><td><label style={{ width: '100%', textAlign: 'left', fontSize: 'larger', fontWeight: 'bolder' }}>Message:</label></td></tr>
                                                <tr>
                                                    <td colSpan="2" style={{ width: '100%' }}>
                                                        <textarea id="user" name="user" className="form-control twfont" value={this.state.invalidDateMessage} disabled  style={{ height: '100px' }} />
                                                    </td>
                                                </tr>
                                                <tr><td><hr /></td></tr>
                                                <tr>
                                                    <td colSpan="2" style={{ width: '80%' }}>
                                                        <button id="butLogin" className="btn twfont" style={{ border: 'solid 1px black', backgroundColor: 'red', color: 'black', fontWeight: 'bolder', width: '95%' }} type="button" onClick={() => { this.ExitModal() }}>OK</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        );
    }

    //Class Methods

    GetCartState() {

        fetch('/api/Product/GetCartCount' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => {
                if (data == "valued") {
                    this.setState({ toClearCartPrompt: true });
                } else {
                    window.location.href = '\\';
                }
            });
    }

    GoToDocumentsManage() {
        this.setState({ toDocumentsManage: true });
    }

    CheckIfAdmin() {
        fetch('/api/Login/isAdmin' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => { this.setState({ isAdminVisibile: (data == 'Y' ? 'visible' : 'hidden') }, () => { console.log('visibility : data=' + data + ' value= ' + this.state.isAdminVisibile); }) })
    }

    GoToOrderSearch() {
        this.setState({ GoToOrderSearch: true });
    }



    toOrderForm() {
        this.setState({ toOrderForm: true });
    }

    GoToLogIn() {
        this.setState({ toLogIn: true });
    }

    GoToAdmin() {
        this.setState({ toAdmin: true });
    }

    GoBackToProducts() {
        this.setState({ toProducts: true });
    }

    GoToBudget() {
        this.setState({ toBudgets: true });
    }

    GoToOrderForm() {
        this.setState({ toOrderForms: true });
    }

    GoToOrderSearch() {
        this.setState({ GoToOrderSearch: true });
    }

    GoToOrderApproval() {
        this.setState({ toOrderApproval: true });
    }

    GoToSavedCarts() {
        this.setState({ toSavedCarts: true });
    }

    GetUserDetails() {
        fetch('api/Login/GetUserDetails' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.json())
            .then(data => { this.setState({ userDetails: data }) })
            .then(() => {
                console.log("user details");
                console.log(this.state.userDetails);
            })
    }

    CheckIfCanTrack() {
        fetch('/api/Login/canTrack' + '?buster=' + new Date().getTime(), { credentials: "same-origin", 'Cache-Control' : 'no-cache, no-store', Pragma : 'no-cache' })
            .then(response => response.text())
            .then(data => { this.setState({ canTrack: (data == 'Y' ? 'visible' : 'hidden') }, () => { console.log('visibility : data=' + data + ' value= ' + this.state.isAdminVisibile); }) })
    }
}